import React, { useState, useEffect } from 'react';

import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Filler,
} from 'chart.js';
import ViolinChartData from './ViolinChartData'; // Import your JSON data

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Filler // For area fills in line charts
);

// Function to map JSON data and create the "violin-like" distribution for each metric
const mapDataForViolin = (data, key) => {
  if (!Array.isArray(data)) {
    console.error('ViolinChartData is not an array');
    return [];
  }
  return data.map((record) => record[key]);
};

// Function to simulate the KDE distribution (mocking a density plot)
const generateViolinDistribution = (data) => {
  // For simplicity, we will generate mirrored data for the violin effect
  const mirroredData = data.map((value, index) => ({
    x: index,
    y: value,
  }));
  // Create the mirrored negative version for violin effect
  const negativeMirroredData = data.map((value, index) => ({
    x: index,
    y: -value,
  }));

  return { mirroredData, negativeMirroredData };
};

const ViolinChart = () => {
  const taskDurationData = mapDataForViolin(ViolinChartData, 'taskDurationDays');
  const costEstimateData = mapDataForViolin(ViolinChartData, 'costEstimateUSD');
  const riskLevelData = mapDataForViolin(ViolinChartData, 'riskLevel');
  const [xAxisName, setXAxisName] = useState('Project'); 
  const [yAxisName, setYAxisName] = useState('Duration (Days)'); 

  const { mirroredData: taskDurationMirrored, negativeMirroredData: taskDurationNegative } = generateViolinDistribution(
    taskDurationData
  );

  const data = {
    labels: taskDurationData.map((_, index) => `Project ${index + 1}`), // X-axis labels
    datasets: [
      {
        label: 'Task Duration (Violin)',
        data: taskDurationMirrored,
        fill: true,
        backgroundColor: 'rgba(255, 165, 0, 0.4)', // Light orange
        borderColor: 'rgba(255, 165, 0, 1)', // Dark orange
        pointRadius: 1, // No scatter points
        tension: 0.3, // Smooth curves
      },
      {
        label: 'Task Duration (Violin Negative)',
        data: taskDurationNegative,
        fill: true,
        backgroundColor: 'rgba(255, 165, 0, 0.4)', // Light orange
        borderColor: 'rgba(255, 165, 0, 1)', // Dark orange
        pointRadius: 0,
        tension: 0.3,
      },
    //   {
    //     label: 'Cost Estimate (USD)',
    //     data: costEstimateData,
    //     borderColor: 'rgba(153, 102, 255, 1)', // Purple
    //     backgroundColor: 'rgba(153, 102, 255, 0.4)',
    //     pointRadius: 2,
    //     type: 'scatter', // Overlaying a scatter plot on top of the violin plot
    //   },
    //   {
    //     label: 'Risk Level',
    //     data: riskLevelData,
    //     borderColor: 'rgba(255, 99, 132, 1)', // Red
    //     backgroundColor: 'rgba(255, 99, 132, 0.4)',
    //     pointRadius: 2,
    //     type: 'scatter',
    //   },
    ],
  };

  const options = {
    scales: {
      x: {
        beginAtZero: true,
        title: {
          display: true,
          text: xAxisName,
          color: 'white', // X-axis label in white
          font: {size: 16},
        },
        ticks: {
          color: 'white', // X-axis ticks (project labels) in white
          font: {size: 16},
        },
      },
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: yAxisName,
          color: 'white', // Y-axis label in white
          font: {size: 16},
        },
        ticks: {
          color: 'white', // Y-axis ticks in white
          font: {size: 16},
        },
      },
    },
    plugins: {
      legend: {
        display: true,
        position: 'top',
        labels: {
          color: 'white', // Legend labels in white
        },
      },
      tooltip: {
        callbacks: {
          label: function (tooltipItem) {
            return `${tooltipItem.dataset.label}: ${tooltipItem.raw.y}`;
          },
        },
        bodyColor: 'white', // Tooltip body text in white
        titleColor: 'white', // Tooltip title text in white
      },
    },
  };

  return (
    <div className="w-full h-128">
      <Line data={data} options={options} />
    </div>
  );
};

export default ViolinChart;
